import React from "react";
import Logo from "../assets/moodLogo.png";
import "./navbar.css";

const Navbar = () => {
  return (
    <div className="navbar">
      <img src={Logo} alt="Mood Indigo Logo" className="logo" />
    </div>
  );
};

export default Navbar;
